export const WEBSITE_NAVIGATOR_UI_COPY = {
  "version": 1,
  "languages": [
    "en",
    "de"
  ],
  "default_language": "en",
  "prompts": {
    "booking": {
      "en": "Book an initial consultation.",
      "de": "Erstgespr\u00e4ch buchen."
    },
    "knowledge": {
      "en": "Ask a question about Weros.",
      "de": "Frage zu Weros stellen."
    },
    "index": {
      "en": "Start Live Website-Check.",
      "de": "Live Website-Check starten."
    },
    "contact": {
      "en": "Prepare contact with the team.",
      "de": "Kontakt mit dem Team vorbereiten."
    },
    "compare": {
      "en": "Compare services.",
      "de": "Leistungen vergleichen."
    }
  },
  "flow_titles": {
    "default": {
      "en": "Navigator result",
      "de": "Navigator-Ergebnis"
    },
    "booking": {
      "en": "Initial consultation",
      "de": "Erstgespr\u00e4ch"
    },
    "website_check": {
      "en": "Live Website-Check",
      "de": "Live Website-Check"
    },
    "comparison": {
      "en": "Comparison",
      "de": "Vergleich"
    },
    "answer": {
      "en": "Answer",
      "de": "Antwort"
    },
    "consent": {
      "en": "Consent",
      "de": "Zustimmung"
    },
    "service_fit": {
      "en": "Service fit",
      "de": "Leistungs-Fit"
    },
    "contact": {
      "en": "Contact",
      "de": "Kontakt"
    },
    "service_cards": {
      "en": "Suitable services",
      "de": "Passende Leistungen"
    },
    "files": {
      "en": "Files",
      "de": "Dateien"
    }
  },
  "mode_descriptions": {
    "service": {
      "en": "Describe your goal, audience or current situation. The Navigator uses that context to suggest suitable services.",
      "de": "Beschreiben Sie Ziel, Zielgruppe oder aktuelle Situation. Der Navigator nutzt das f\u00fcr passende Leistungsvorschl\u00e4ge."
    },
    "service_results": {
      "en": "These services fit your described situation:",
      "de": "Diese Leistungen passen zu Ihrer beschriebenen Situation:"
    },
    "booking": {
      "en": "Pick a free slot in your timezone. Then confirm it with your contact details.",
      "de": "W\u00e4hlen Sie einen freien Termin in Ihrer Zeitzone. Danach best\u00e4tigen Sie ihn mit Ihren Kontaktdaten."
    },
    "booking_finalize": {
      "en": "Check the selected slot and add your contact details. Submitting confirms the appointment.",
      "de": "Pr\u00fcfen Sie den gew\u00e4hlten Termin und erg\u00e4nzen Sie Ihre Kontaktdaten. Das Absenden best\u00e4tigt den Termin."
    },
    "booking_summary": {
      "en": "Your appointment is confirmed here. Use the actions if you need to reschedule or cancel.",
      "de": "Ihr Termin ist hier best\u00e4tigt. Nutzen Sie die Aktionen, falls Sie verschieben oder absagen m\u00fcssen."
    },
    "booking_cancelled": {
      "en": "The appointment was cancelled. Start a new booking if another slot is still available.",
      "de": "Der Termin wurde abgesagt. Starten Sie bei Bedarf eine neue Buchung, sofern noch ein Slot verf\u00fcgbar ist."
    },
    "contact": {
      "en": "Share your request and contact details. The message is prepared for the Weros team.",
      "de": "Teilen Sie Anfrage und Kontaktdaten. Die Nachricht wird f\u00fcr das Weros-Team vorbereitet."
    },
    "contact_summary": {
      "en": "Review the prepared inquiry and next steps before sending your details.",
      "de": "Pr\u00fcfen Sie die vorbereitete Anfrage und die n\u00e4chsten Schritte, bevor Sie Ihre Daten absenden."
    },
    "contact_confirmation": {
      "en": "Your inquiry was sent. The team can use these details to follow up.",
      "de": "Ihre Anfrage wurde gesendet. Das Team kann diese Angaben f\u00fcr die R\u00fcckmeldung nutzen."
    },
    "contact_upload": {
      "en": "Attach only files that clarify your request. Allowed formats are shown here.",
      "de": "F\u00fcgen Sie nur Dateien hinzu, die Ihre Anfrage kl\u00e4ren. Erlaubte Formate stehen direkt hier."
    },
    "website_check": {
      "en": "Enter the website URL, confirm permission and start the live check.",
      "de": "Tragen Sie die Website-URL ein, best\u00e4tigen Sie die Berechtigung und starten Sie den Live-Check."
    },
    "website_check_progress": {
      "en": "Watch the live check progress here. Open the report when the check is finished.",
      "de": "Verfolgen Sie den Live-Check hier. Wenn er fertig ist, k\u00f6nnen Sie den Report \u00f6ffnen."
    },
    "comparison": {
      "en": "Compare selected services by decision criteria and use the recommendation for the next step.",
      "de": "Vergleichen Sie ausgew\u00e4hlte Leistungen nach Entscheidungskriterien und nutzen Sie die Empfehlung als n\u00e4chsten Schritt."
    }
  },
  "labels": {
    "ready": {
      "en": "Ready",
      "de": "Bereit"
    },
    "navigator": {
      "en": "Navigator",
      "de": "Navigator"
    },
    "busy": {
      "en": "Working",
      "de": "Arbeite"
    },
    "error": {
      "en": "Connection failed",
      "de": "Verbindung fehlgeschlagen"
    },
    "noMatch": {
      "en": "There is no information in the system regarding this. Consider contacting our team instead.",
      "de": "Dazu liegen im System keine Informationen vor. Kontaktieren Sie stattdessen gerne unser Team."
    },
    "contactTeam": {
      "en": "Contact team",
      "de": "Team kontaktieren"
    },
    "connectionFailed": {
      "en": "Connection to the Navigator failed.",
      "de": "Verbindung zum Navigator fehlgeschlagen."
    },
    "required": {
      "en": "Please complete the required fields.",
      "de": "Bitte f\u00fcllen Sie die Pflichtfelder aus."
    },
    "consent": {
      "en": "Please confirm consent first.",
      "de": "Bitte best\u00e4tigen Sie zuerst die Zustimmung."
    },
    "unavailable": {
      "en": "This function is currently unavailable.",
      "de": "Diese Funktion ist gerade nicht verf\u00fcgbar."
    },
    "slots": {
      "en": "Available slots",
      "de": "Verf\u00fcgbare Termine"
    },
    "loadSlots": {
      "en": "Load slots",
      "de": "Termine laden"
    },
    "loadingSlots": {
      "en": "Loading slots...",
      "de": "Termine werden geladen..."
    },
    "selectDay": {
      "en": "Select day",
      "de": "Tag ausw\u00e4hlen"
    },
    "selectSlot": {
      "en": "Select Slot",
      "de": "Termin ausw\u00e4hlen"
    },
    "slotSelected": {
      "en": "Slot selected",
      "de": "Termin ausgew\u00e4hlt"
    },
    "timezoneSetting": {
      "en": "Timezone",
      "de": "Zeitzone"
    },
    "preferredTime": {
      "en": "Preferred time",
      "de": "Wunschzeit"
    },
    "weekView": {
      "en": "Week",
      "de": "Woche"
    },
    "monthView": {
      "en": "Month",
      "de": "Monat"
    },
    "previousPeriod": {
      "en": "Previous period",
      "de": "Vorheriger Zeitraum"
    },
    "nextPeriod": {
      "en": "Next period",
      "de": "N\u00e4chster Zeitraum"
    },
    "previousDay": {
      "en": "Previous day",
      "de": "Vorheriger Tag"
    },
    "nextDay": {
      "en": "Next day",
      "de": "N\u00e4chster Tag"
    },
    "calendarWeek": {
      "en": "Week",
      "de": "KW"
    },
    "noAvailableDays": {
      "en": "No free days in this range.",
      "de": "Keine freien Tage in diesem Zeitraum."
    },
    "availableSlot": {
      "en": "Available",
      "de": "Verf\u00fcgbar"
    },
    "unavailableSlot": {
      "en": "Not available",
      "de": "Nicht verf\u00fcgbar"
    },
    "zeroSlots": {
      "en": "0 Slots",
      "de": "0 Termine"
    },
    "slotSingular": {
      "en": "slot",
      "de": "Termin"
    },
    "slotPlural": {
      "en": "slots",
      "de": "Termine"
    },
    "reserve": {
      "en": "Reserve",
      "de": "Reservieren"
    },
    "send": {
      "en": "Send",
      "de": "Absenden"
    },
    "inquirySent": {
      "en": "Inquiry sent.",
      "de": "Anfrage gesendet."
    },
    "inquirySentTitle": {
      "en": "Message sent",
      "de": "Nachricht gesendet"
    },
    "inquirySentBody": {
      "en": "The message was sent to the Weros team. The team will review the request and get back to you.",
      "de": "Die Nachricht wurde an das Weros-Team \u00fcbermittelt. Das Team pr\u00fcft die Anfrage und meldet sich passend zur\u00fcck."
    },
    "confirmBooking": {
      "en": "Confirm Booking",
      "de": "Buchung best\u00e4tigen"
    },
    "startCheck": {
      "en": "Start Live Website-Check",
      "de": "Live Website-Check starten"
    },
    "openLiveView": {
      "en": "Open live view",
      "de": "Live-Ansicht \u00f6ffnen"
    },
    "openReport": {
      "en": "Open Report",
      "de": "Report \u00f6ffnen"
    },
    "livePreview": {
      "en": "Live view",
      "de": "Live-Ansicht"
    },
    "upload": {
      "en": "Upload file",
      "de": "Datei hochladen"
    },
    "inputPlaceholder": {
      "en": "Ask a question",
      "de": "Frage stellen"
    },
    "sendMessage": {
      "en": "Send message",
      "de": "Nachricht absenden"
    },
    "bottomBarCollapse": {
      "en": "Collapse quick bar",
      "de": "Schnellleiste einklappen"
    },
    "bottomBarExpand": {
      "en": "Expand quick bar",
      "de": "Schnellleiste ausklappen"
    },
    "privacy": {
      "en": "Weros may process this information to handle the request.",
      "de": "Weros darf diese Angaben zur Bearbeitung der Anfrage verarbeiten."
    },
    "privacyLegal": {
      "en": "Privacy information",
      "de": "Datenschutzhinweise"
    },
    "inquiryMessage": {
      "en": "Message",
      "de": "Nachricht"
    },
    "finalizeBooking": {
      "en": "Finalize Booking",
      "de": "Buchung abschlie\u00dfen"
    },
    "appointmentConfirmed": {
      "en": "Appointment confirmed",
      "de": "Termin best\u00e4tigt"
    },
    "appointmentCancelled": {
      "en": "Appointment cancelled",
      "de": "Termin storniert"
    },
    "selectedSlot": {
      "en": "Selected slot",
      "de": "Ausgew\u00e4hlter Termin"
    },
    "changeSlot": {
      "en": "Change",
      "de": "\u00c4ndern"
    },
    "withStaff": {
      "en": "With",
      "de": "Mit"
    },
    "rescheduleBooking": {
      "en": "Reschedule",
      "de": "Umbuchen"
    },
    "cancelBooking": {
      "en": "Cancel appointment",
      "de": "Termin stornieren"
    },
    "bookNewConsultation": {
      "en": "Book new consultation",
      "de": "Neues Erstgespr\u00e4ch buchen"
    },
    "rebookingRequiresCancel": {
      "en": "To choose another slot, cancel the current appointment first.",
      "de": "Um einen neuen Termin zu w\u00e4hlen, muss der aktuelle Termin zuerst storniert werden."
    },
    "rebookingLimitNotice": {
      "en": "This appointment can still be cancelled, but no further booking can be started in this session afterwards.",
      "de": "Dieser Termin kann noch storniert werden, danach kann in dieser Session aber keine weitere Buchung gestartet werden."
    },
    "bookingEmailNotice": {
      "en": "A confirmation was sent by email.",
      "de": "Eine Best\u00e4tigung wurde per E-Mail gesendet."
    },
    "alreadyRescheduledTwice": {
      "en": "You have already rescheduled your appointment twice.",
      "de": "Du hast deinen Termin bereits zweimal umgebucht."
    },
    "finalBookingNotice": {
      "en": "Final booking option for this session.",
      "de": "Letzte Buchungsm\u00f6glichkeit in dieser Session."
    },
    "cancelWindowExpiredNotice": {
      "en": "This appointment is now fixed because the cancellation window has expired.",
      "de": "Dieser Termin ist jetzt verbindlich, weil das Stornierungsfenster abgelaufen ist."
    },
    "appointmentCancelledNotice": {
      "en": "The appointment was cancelled.",
      "de": "Der Termin wurde storniert."
    },
    "cancelledCanBookAgain": {
      "en": "You can book another appointment in this session.",
      "de": "Du kannst in dieser Session einen neuen Termin w\u00e4hlen."
    },
    "cancelLimitReached": {
      "en": "The booking and cancellation limit for this session has been reached.",
      "de": "Das Buchungs- und Stornierungslimit f\u00fcr diese Session ist erreicht."
    },
    "phoneOptional": {
      "en": "Phone (optional)",
      "de": "Telefon (optional)"
    },
    "websiteOptional": {
      "en": "Website URL (optional)",
      "de": "Website-URL (optional)"
    },
    "websiteCheckConsent": {
      "en": "Weros may analyze this website URL to create the Website-Check result.",
      "de": "Weros darf diese Website-URL analysieren, um das Website-Check-Ergebnis zu erstellen."
    },
    "websiteCheckFinished": {
      "en": "The Website-Check is finished. Open the report or start the check for a different website.",
      "de": "Der Website-Check ist fertig. \u00d6ffnen Sie den Report oder starten Sie den Check f\u00fcr eine andere Website."
    },
    "websiteCheckFinishedChip": {
      "en": "Website-Check finished",
      "de": "Website-Check fertig"
    },
    "websiteCheckSummary": {
      "en": "Summary",
      "de": "Zusammenfassung"
    },
    "websiteCheckSummaryEmpty": {
      "en": "The result summary is not available yet.",
      "de": "Die Ergebnis-Zusammenfassung ist noch nicht verf\u00fcgbar."
    },
    "websiteCheckSummaryPreparing": {
      "en": "The result summary is being prepared.",
      "de": "Die Ergebnis-Zusammenfassung wird vorbereitet."
    },
    "websiteCheckHistory": {
      "en": "Previous Website-Checks",
      "de": "Bisherige Website-Checks"
    },
    "websiteCheckRunsUsed": {
      "en": "Website-Checks in this session",
      "de": "Website-Checks in dieser Session"
    },
    "websiteCheckLastRun": {
      "en": "This is the final Website-Check for this session.",
      "de": "Das ist der letzte Website-Check in dieser Session."
    },
    "websiteCheckLimitReached": {
      "en": "The maximum number of Website-Checks for this session has been reached.",
      "de": "Die maximale Anzahl an Website-Checks f\u00fcr diese Session ist erreicht."
    },
    "startForAnotherSite": {
      "en": "Start for another site",
      "de": "F\u00fcr andere Website starten"
    },
    "reportPreparing": {
      "en": "Report is being prepared",
      "de": "Report wird vorbereitet"
    },
    "searchCountry": {
      "en": "Search country",
      "de": "Land suchen"
    },
    "missingFields": {
      "en": "Missing information",
      "de": "Fehlende Angaben"
    },
    "missingName": {
      "en": "Name",
      "de": "Name"
    },
    "missingEmail": {
      "en": "valid email",
      "de": "g\u00fcltige E-Mail"
    },
    "missingMessage": {
      "en": "message",
      "de": "Nachricht"
    },
    "missingPrivacy": {
      "en": "privacy consent",
      "de": "Datenschutz-Zustimmung"
    },
    "modeOpened": {
      "en": "Open",
      "de": "Offen"
    },
    "modeAssistance": {
      "en": "Assistance",
      "de": "Assistenz"
    },
    "modeBooked": {
      "en": "Booked",
      "de": "Gebucht"
    },
    "modeSent": {
      "en": "Sent",
      "de": "Gesendet"
    },
    "modeAnalyzed": {
      "en": "Analyzed",
      "de": "Analysiert"
    },
    "slotReserved": {
      "en": "Slot reserved for 30 minutes.",
      "de": "Termin f\u00fcr 30 Minuten reserviert."
    },
    "bookingConfirmed": {
      "en": "Booking confirmed.",
      "de": "Termin best\u00e4tigt."
    },
    "bookingCancelled": {
      "en": "Appointment cancelled.",
      "de": "Termin storniert."
    },
    "voiceStart": {
      "en": "Start voice input",
      "de": "Spracheingabe starten"
    },
    "voiceStop": {
      "en": "Stop voice input",
      "de": "Spracheingabe stoppen"
    },
    "voiceUnsupported": {
      "en": "Voice input is not available in this browser.",
      "de": "Spracheingabe ist in diesem Browser nicht verf\u00fcgbar."
    },
    "voiceDenied": {
      "en": "Microphone access was denied.",
      "de": "Der Mikrofonzugriff wurde abgelehnt."
    },
    "voiceError": {
      "en": "Voice input failed.",
      "de": "Spracheingabe fehlgeschlagen."
    },
    "voiceTranscribing": {
      "en": "Transcribing",
      "de": "Wird transkribiert"
    },
    "teamMember": {
      "en": "Team member",
      "de": "Team-Mitglied"
    },
    "websiteUrl": {
      "en": "Website URL",
      "de": "Website-URL"
    },
    "liveWebsiteCheck": {
      "en": "Live Website-Check",
      "de": "Live Website-Check"
    },
    "liveWebsiteCheckProgress": {
      "en": "Live Website-Check progress",
      "de": "Fortschritt Live Website-Check"
    },
    "reason": {
      "en": "Reason",
      "de": "Begr\u00fcndung"
    },
    "openServicePage": {
      "en": "Open page",
      "de": "Seite \u00f6ffnen"
    },
    "servicePageAskPrompt": {
      "en": "Ask about anything that is unclear to you about the service {service_name}",
      "de": "Fragen Sie alles, was Ihnen zum Service {service_name} unklar ist."
    },
    "serviceFinderSubmit": {
      "en": "Find suitable services",
      "de": "Passende Leistungen finden"
    },
    "allow": {
      "en": "Allow",
      "de": "Zustimmen"
    },
    "open": {
      "en": "Open",
      "de": "\u00d6ffnen"
    },
    "download": {
      "en": "Download",
      "de": "Download"
    },
    "fileDocumentsTitle": {
      "en": "Fitting Documents for more details about this:",
      "de": "Passende Dokumente mit weiteren Details dazu:"
    },
    "fileMediaTitle": {
      "en": "Fitting Media pieces:",
      "de": "Passende Medienbeispiele:"
    },
    "fileMediaOpenLabel": {
      "en": "Open media preview",
      "de": "Medienvorschau \u00f6ffnen"
    },
    "fileMediaCloseLabel": {
      "en": "Close media preview",
      "de": "Medienvorschau schlie\u00dfen"
    },
    "fileDocumentFallback": {
      "en": "Document",
      "de": "Dokument"
    },
    "fileMediaFallback": {
      "en": "Media",
      "de": "Medium"
    },
    "websiteCheckStarted": {
      "en": "Live Website-Check started.",
      "de": "Live Website-Check gestartet."
    },
    "addMoreContext": {
      "en": "Please add a little more context.",
      "de": "Bitte erg\u00e4nzen Sie etwas mehr Kontext."
    },
    "navigatorEnabled": {
      "en": "Navigator enabled.",
      "de": "Navigator aktiviert."
    },
    "situationTitle": {
      "en": "Situation",
      "de": "Ausgangslage"
    },
    "fitTitle": {
      "en": "Fit",
      "de": "Einordnung"
    },
    "summaryTitle": {
      "en": "Summary",
      "de": "Zusammenfassung"
    },
    "sourcesTitle": {
      "en": "Sources",
      "de": "Quellen"
    },
    "noSlotsAvailable": {
      "en": "No slots are available.",
      "de": "Keine Termine verf\u00fcgbar."
    },
    "forwardInquiry": {
      "en": "Forward inquiry",
      "de": "Anfrage weiterleiten"
    },
    "name": {
      "en": "Name",
      "de": "Name"
    },
    "email": {
      "en": "Email",
      "de": "E-Mail"
    },
    "reserveSlotFirst": {
      "en": "Please reserve a slot first.",
      "de": "Bitte reservieren Sie zuerst einen Termin."
    },
    "inquiryBriefing": {
      "en": "Inquiry briefing",
      "de": "Anfrage-Briefing"
    },
    "fileUpload": {
      "en": "File upload",
      "de": "Datei-Upload"
    },
    "allowed": {
      "en": "Allowed",
      "de": "Erlaubt"
    },
    "uploadConsent": {
      "en": "Upload this file for the current request.",
      "de": "Diese Datei f\u00fcr die aktuelle Anfrage hochladen."
    },
    "uploadReceived": {
      "en": "Upload received. Scan is running.",
      "de": "Upload erhalten. Der Scan l\u00e4uft."
    },
    "fileReady": {
      "en": "File is ready.",
      "de": "Datei ist bereit."
    },
    "attachFiles": {
      "en": "Attach Files",
      "de": "Dateien anh\u00e4ngen"
    },
    "uploadingFile": {
      "en": "Uploading file",
      "de": "Datei wird hochgeladen"
    },
    "waitForUploads": {
      "en": "Please wait until all files are ready.",
      "de": "Bitte warten, bis alle Dateien bereit sind."
    },
    "tooManyFiles": {
      "en": "The file limit has been reached.",
      "de": "Das Datei-Limit ist erreicht."
    },
    "removeFile": {
      "en": "Remove file",
      "de": "Datei entfernen"
    },
    "nextStep": {
      "en": "Next step",
      "de": "N\u00e4chster Schritt"
    },
    "commonQuestions": {
      "en": "Common questions",
      "de": "H\u00e4ufige Fragen"
    },
    "hint": {
      "en": "Hint",
      "de": "Hinweis"
    },
    "possibleNextSteps": {
      "en": "Possible next steps",
      "de": "M\u00f6gliche n\u00e4chste Schritte"
    }
  },
  "loading_messages": {
    "navigator_opening": {
      "en": "Navigator is opening",
      "de": "Navigator wird ge\u00f6ffnet"
    },
    "module_opening": {
      "en": "{module} is opening",
      "de": "{module} wird ge\u00f6ffnet"
    },
    "default": {
      "en": "Working on it",
      "de": "Wird verarbeitet"
    },
    "transcribing": {
      "en": "Transcribing",
      "de": "Wird transkribiert"
    },
    "modules": {
      "assistance": {
        "en": "Finding a grounded answer",
        "de": "Fundierte Antwort wird gesucht"
      },
      "find_right_service": {
        "en": "Evaluating services",
        "de": "Leistungen werden eingeordnet"
      },
      "contact": {
        "en": "Preparing your inquiry",
        "de": "Anfrage wird vorbereitet"
      },
      "appointment": {
        "en": "Preparing appointment options",
        "de": "Terminoptionen werden vorbereitet"
      },
      "website_check": {
        "en": "Preparing Website-Check",
        "de": "Website-Check wird vorbereitet"
      }
    },
    "actions": {
      "navigator.consent.accept": {
        "en": "Saving consent",
        "de": "Zustimmung wird gespeichert"
      },
      "scheduling.fetch_slots": {
        "en": "Loading available slots",
        "de": "Verf\u00fcgbare Termine werden geladen"
      },
      "scheduling.reserve_slot": {
        "en": "Reserving slot",
        "de": "Termin wird reserviert"
      },
      "scheduling.confirm_booking": {
        "en": "Confirming appointment",
        "de": "Termin wird best\u00e4tigt"
      },
      "scheduling.cancel_booking": {
        "en": "Cancelling appointment",
        "de": "Termin wird storniert"
      },
      "contact.draft.save": {
        "en": "Preparing your inquiry",
        "de": "Anfrage wird vorbereitet"
      },
      "inquiry.create": {
        "en": "Sending inquiry",
        "de": "Anfrage wird gesendet"
      },
      "upload.prepare": {
        "en": "Preparing upload",
        "de": "Upload wird vorbereitet"
      },
      "upload.file": {
        "en": "Uploading file",
        "de": "Datei wird hochgeladen"
      },
      "upload.status": {
        "en": "Scanning file",
        "de": "Datei wird gepr\u00fcft"
      },
      "website_check.start": {
        "en": "Preparing Website-Check",
        "de": "Website-Check wird vorbereitet"
      },
      "website_check.running": {
        "en": "Checking website",
        "de": "Website wird gepr\u00fcft"
      }
    }
  },
  "status_messages": {
    "ready": {
      "en": "Ready",
      "de": "Bereit"
    },
    "idle": {
      "en": "Idle",
      "de": "Wartet"
    },
    "not_configured": {
      "en": "Not configured yet",
      "de": "Noch nicht konfiguriert"
    },
    "queued": {
      "en": "Queued",
      "de": "In der Warteschlange"
    },
    "running": {
      "en": "Running",
      "de": "L\u00e4uft"
    },
    "completed": {
      "en": "Completed",
      "de": "Abgeschlossen"
    },
    "partial_done": {
      "en": "Partly completed",
      "de": "Teilweise abgeschlossen"
    },
    "no_staff_configured": {
      "en": "No team member is assigned to this booking group yet.",
      "de": "F\u00fcr diesen Terminbereich ist noch kein Team-Mitglied zugeordnet."
    },
    "min_lead_time": {
      "en": "This time range is too early. Please choose a later day.",
      "de": "Dieser Zeitraum liegt zu fr\u00fch. Bitte w\u00e4hlen Sie einen sp\u00e4teren Tag."
    },
    "slot_unavailable": {
      "en": "This slot is no longer available.",
      "de": "Dieser Termin ist nicht mehr verf\u00fcgbar."
    },
    "active_booking_exists": {
      "en": "This session already has a confirmed appointment.",
      "de": "F\u00fcr diese Session ist bereits ein Termin best\u00e4tigt."
    },
    "cancel_rebook_limit_reached": {
      "en": "The booking and cancellation limit for this session has been reached.",
      "de": "Das Buchungs- und Stornierungslimit f\u00fcr diese Session ist erreicht."
    },
    "cancelled": {
      "en": "Appointment cancelled.",
      "de": "Termin storniert."
    },
    "cancelled_for_rebooking": {
      "en": "Appointment cancelled. Please choose a new slot.",
      "de": "Termin storniert. Bitte w\u00e4hlen Sie einen neuen Termin."
    },
    "booking_not_found": {
      "en": "The appointment could not be found.",
      "de": "Der Termin wurde nicht gefunden."
    },
    "booking_not_cancellable": {
      "en": "This appointment can no longer be cancelled.",
      "de": "Dieser Termin kann nicht mehr storniert werden."
    },
    "booking_token_invalid": {
      "en": "The appointment link is invalid.",
      "de": "Der Termin-Link ist ung\u00fcltig."
    },
    "cancel_window_expired": {
      "en": "The cancellation window has expired.",
      "de": "Das Stornierungsfenster ist abgelaufen."
    },
    "reservation_not_found": {
      "en": "The reservation could not be found.",
      "de": "Die Reservierung wurde nicht gefunden."
    },
    "reservation_not_available": {
      "en": "The reservation is no longer available.",
      "de": "Die Reservierung ist nicht mehr verf\u00fcgbar."
    },
    "reservation_expired": {
      "en": "The reservation has expired.",
      "de": "Die Reservierung ist abgelaufen."
    },
    "requires_consent": {
      "en": "Please confirm consent.",
      "de": "Bitte Zustimmung best\u00e4tigen."
    },
    "scan_pending": {
      "en": "Scan pending",
      "de": "Scan l\u00e4uft"
    },
    "scan_failed": {
      "en": "Scan failed",
      "de": "Scan fehlgeschlagen"
    },
    "rejected": {
      "en": "File rejected",
      "de": "Datei abgelehnt"
    },
    "created": {
      "en": "Created",
      "de": "Erstellt"
    },
    "submitted": {
      "en": "Submitted",
      "de": "Gesendet"
    },
    "confirmed": {
      "en": "Confirmed",
      "de": "Best\u00e4tigt"
    },
    "booked": {
      "en": "Confirmed",
      "de": "Best\u00e4tigt"
    }
  }
};
